export function getEventColor(type , eventsColors , isUmbracoEvent){
    if(isUmbracoEvent){
        // console.log('eventsColors',eventsColors , 'type' , type)
        const selectedType = eventsColors.filter((item)=> item.eventName == type);
        return selectedType.length > 0 ? selectedType[0]?.eventColor : '#000';
    }else{
        const selectedType = eventsColors.filter((item)=> item.eventCode == type);
        return selectedType.length > 0 ? selectedType[0]?.eventColor : '#000';
    }
}